window.$ = window.jQuery = $ = jQuery = require("jquery");
require("popper.js");
require("bootstrap");
require("./commons/mailme");
require("./commons/smoothscroll");
require('./commons/navigation');
require('./commons/maps');
require('./commons/center-maps');
require('./commons/footer');
require('./commons/tiny-slider');
//import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";


$(document).ready(() => {
    $("span.mailme").mailme();
});